import { Component, forwardRef, Input, OnInit } from '@angular/core'
import { TableData } from '../../models/table-data'
import { EntityData } from '../../models/entity-data'
import { of } from 'rxjs'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'

/**
 *
 * displays a dynamic table of entities with a checkbox to select none or more entities
 * selection is returned to the ngModel
 * implementation according to: https://www.digitalocean.com/community/tutorials/angular-custom-form-control
 *
 * Inputs:
 *  data: array of entities (as in EntityData.data) to be displayed
 *  listType: only "Reference" possible at the moment
 *  referenceType: <DTOType> to be listed
 *
 * How does it work:
 *  component takes data and referenceType as input. Both are required to compile TableData for the dynamic table.
 *  the dynammic table displays the entities with a checkbox before each row. It emits each click of a checkBox (event entitySelectionListChanged)
 *  each event triggers propagateChange() which then updates the ngModel and the value within the form of the parent component.
 */

@Component({
  selector: 'jml-lib-select-list',
  templateUrl: './select-list.component.html',
  styleUrls: ['./select-list.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectListComponent),
      multi: true
    }
  ]
})
export class SelectListComponent implements OnInit, ControlValueAccessor {
  @Input() data: any
  @Input() referenceType: string
  @Input() listType: string

  entitySelectionListTableData: TableData

  constructor() {}

  ngOnInit(): void {
    this.generateDataforSelectList(this.data, this.referenceType)
  }

  generateDataforSelectList(data: any[], dtoType: string) {
    // create EntityData, set some pageSize and count to data.lengt (no paging possible)
    // TODO Uwe: implement GUI paging later
    const entityData$ = of(new EntityData(data, dtoType, data.length, undefined, data.length))
    this.entitySelectionListTableData = new TableData(dtoType)
      .hideAttachments()
      .disableInlineEdit()
      .hideAttachments()
      .hideButtons()
      .disablePagination()
      .displaySelectList()
      .hideHeader()
      .setDataSource(entityData$)
  }

  writeValue = () => {}
  propagateChange = (entitySelectionList: number[]) => {}

  registerOnChange(fn: () => void): void {
    this.propagateChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  onTouched = () => {}
}
